require('slick-carousel')

$(() => {
  if (!$(document.body).hasClass('page--whiteboard')) return

  //┌───────────────────────────────────────────┐
  //│   CONSTANTS (DEFINITION ORDER MATTERS!!!) │
  //└───────────────────────────────────────────┘
  // GENERAL OBJECTS
  const controller = new ScrollMagic.Controller(),
    MILLISECONDS_ONE_SECOND = 1000,
    STRING_EMPTY = ''

  // SLICK CAROUSEL
  const SLIDE_DURATION_SECONDS = 4

  // SCROLLMAGIC
  const DELAY_INTERVAL_SECONDS = 0.05,
    DELAY_INITIAL_SECONDS = 0.1,
    TWEEN_DURATION_SECONDS = 1,
    EASE_EXPO_OUT = Expo.easeOut,
    EASE_EXPO_IN_OUT = Expo.easeInOut,
    SHOW_INDICATORS = false, // Set to `true` for debugging
    TRIGGER_HOOK_REVEAL = 0.9,
    TRIGGER_HOOK_CAROUSEL = 0.2,
    TRIGGER_HOOK_CAROUSEL_IMAGE = TRIGGER_HOOK_CAROUSEL + 0.3

  // WIDTHS
  const WIDTH_MAX_MOBILE = 767,
    WIDTH_MIN_MINITABLET = 768,
    WIDTH_MAX_MINITABLET = 1023,
    WIDTH_MIN_TABLET = 1024,
    WIDTH_MAX_TABLET = 1439,
    WIDTH_MIN_DESKTOP = 1440

  // BREAKPOINTS
  const BREAKPOINT_MOBILE = 'mobile',
    BREAKPOINT_MINITABLET = 'minitablet',
    BREAKPOINT_TABLET = 'tablet',
    BREAKPOINT_DESKTOP = 'desktop',
    BREAKPOINT_INITIAL = get_view()

  // CSS
  const CLASS_TEXT_GROUP = 'js_text-group',
    CLASS_CAROUSEL_MOBILE = 'js_mobile-carousel',
    CLASS_CAROUSEL_TEXT_ITEM_MOBILE = 'js_mobile-carousel-text-item',
    CLASS_CAROUSEL_TEXT_ITEM_MOBILE_ACTIVE = '-active',
    CLASS_CAROUSEL_IMAGE_LIST = 'js_carousel-image-list',
    CLASS_CAROUSEL_IMAGE_ITEM = 'js_carousel-image-item',
    CLASS_CAROUSEL_TEXT_CONTAINER = 'js_carousel-text-container',
    CLASS_CAROUSEL_TEXT_GROUP = 'js_carousel-text-group',
    CLASS_CAROUSEL_TEXT_ITEM = 'js_carousel-text-item',
    CLASS_CAROUSEL_TEXT_ITEM_ACTIVE = '-active',
    CLASS_ANIMATION_REVEAL = 'move',
    CLASS_ANIMATION_BASE = 'js_move',
    CLASS_ANIMATION_INITIAL = `${CLASS_ANIMATION_BASE}--${BREAKPOINT_INITIAL}`

  // CACHED JQUERY OBJECTS
  const $move_items = $(`.${CLASS_ANIMATION_REVEAL}`),
    $mobile_carousel = $(`.${CLASS_CAROUSEL_MOBILE}`),
    $carousel_image_list = $(`.${CLASS_CAROUSEL_IMAGE_LIST}`),
    $carousel_image_items = $(`.${CLASS_CAROUSEL_IMAGE_ITEM}`),
    $carousel_text_container = $(`.${CLASS_CAROUSEL_TEXT_CONTAINER}`),
    $carousel_text_group = $(`.${CLASS_CAROUSEL_TEXT_GROUP}`),
    $carousel_text_items = $(`.${CLASS_CAROUSEL_TEXT_ITEM}`)

  //┌───────────┐
  //│ VARIABLES │
  //└───────────┘
  let is_autoscrolling

  //┌──────────────┐
  //│ SCRIPT START │
  //└──────────────┘
  initialize_page()

  const _COUNTER_CONTEXT = this,
    _items = find_all(`.${CLASS_ANIMATION_INITIAL}`),
    _view_is_mobile = view_is_mobile()

  let _delay_seconds = 0,
    _delay_seconds_total = DELAY_INITIAL_SECONDS,
    _delay_seconds_total_is_reset,
    _counter = get_counter(
      _items.length,
      on_all_items_revealed,
      _COUNTER_CONTEXT,
    )

  if (_view_is_mobile) {
    start_mobile_carousel()
  }

  for (let i = 0; i < _items.length; i++) {
    let _item = _items[i],
      _item_is_visible = item_is_visible(_item),
      _item_will_animate = item_will_animate(_item)

    if (_item_is_visible) {
      // Add staggered delay for elements which are visible on page load
      if (!_delay_seconds_total_is_reset) {
        _delay_seconds_total = DELAY_INITIAL_SECONDS
        _delay_seconds_total_is_reset = true
      }

      _delay_seconds = _delay_seconds_total
      _delay_seconds_total += DELAY_INTERVAL_SECONDS
    } else {
      _delay_seconds = 0
    }

    _delay_seconds += get_custom_delay_seconds(_item)

    // Do not animate elements above what is visible on page load
    if (_item_will_animate) {
      const _scene_move = new ScrollMagic.Scene({
        triggerElement: _item,
        triggerHook: TRIGGER_HOOK_REVEAL,
        reverse: false,
      }).setTween(_item, TWEEN_DURATION_SECONDS, {
        opacity: 1,
        y: 0,
        ease: EASE_EXPO_OUT,
        delay: _delay_seconds,
        onComplete: function() {
          unmove(_item)
          _counter()
        },
        onCompleteScope: _item,
      })

      if (_view_is_mobile) {
        // Start mobile carousel on scene start
        _scene_move.on('start', (_event) => {
          if (_item.contains($mobile_carousel[0])) {
            start_mobile_carousel()
          }
        })
      }

      if (view_is_tablet() || view_is_desktop()) {
        if ($(_item).hasClass(CLASS_TEXT_GROUP)) {
          let _parent_text_group = _item.parentNode,
            _height_parent = $(_parent_text_group).innerHeight(),
            _height_item = $(_item).innerHeight(),
            _offset_y_text_group = -(_height_parent - _height_item) / 2

          _scene_move.offset(_offset_y_text_group)
          unmove(
            $(_item)
              .children()
              .toArray(),
          )
        }
      }

      add_scene_indicators(_scene_move).addTo(controller)
    } else {
      unmove(_item)
      _counter()
    }
  }

  if (!_view_is_mobile) {
    const _scene_carousel_text_group = new ScrollMagic.Scene({
      duration: get_real_duration(),
      triggerElement: $carousel_text_group[0],
      triggerHook: TRIGGER_HOOK_CAROUSEL,
    })
      .on('shift', function(_event) {
        this.duration(get_real_duration)
      })
      .setPin($carousel_text_group[0])
      .addTo(controller)

    add_scene_indicators(_scene_carousel_text_group)

    $carousel_image_items.each((_index, _item) => {
      const _indicator_label = `image highlight ${_index}`

      const _scene_carousel_image_highlight = new ScrollMagic.Scene({
        duration: $(_item).outerHeight(),
        triggerElement: _item,
        triggerHook: TRIGGER_HOOK_CAROUSEL_IMAGE,
      })
        .on('start', (_event) => {
          if (!is_autoscrolling) {
            set_active_item(
              CLASS_CAROUSEL_TEXT_ITEM,
              CLASS_CAROUSEL_TEXT_ITEM_ACTIVE,
              _index,
            )
          }
        })
        .on('end', (_event) => {
          if (!is_autoscrolling) {
            set_active_item(
              CLASS_CAROUSEL_TEXT_ITEM,
              CLASS_CAROUSEL_TEXT_ITEM_ACTIVE,
              _index,
            )
          }
        })
        .addTo(controller)

      add_scene_indicators(_scene_carousel_image_highlight, _indicator_label)
    })
  }
  //┌────────────┐
  //│ SCRIPT END │
  //└────────────┘

  //┌───────────┐
  //│ FUNCTIONS │
  //└───────────┘
  function add_scene_indicators(_scene, _label) {
    if (SHOW_INDICATORS) {
      add_scene_indicators = function(_scene, _label) {
        if (_label) {
          _scene.addIndicators({ name: _label })
        } else {
          _scene.addIndicators()
        }

        return _scene
      }
    } else {
      add_scene_indicators = (_scene) => _scene
    }

    return add_scene_indicators(_scene)
  }

  function find_all(_selector) {
    let _nodes = document.querySelectorAll(_selector)

    return Array.prototype.slice.call(_nodes)
  }

  function get_counter(_end, _callback, _context) {
    // Invokes `_callback` when returned function is invoked `_end` times
    let _count = 0

    return () => {
      _count++

      if (_count === _end) {
        _callback.call(_context)
      }

      return _count
    }
  }

  function get_custom_delay_seconds(_item) {
    const _tween_delay_seconds = [
      'tweenDelaySeconds',
      `${BREAKPOINT_INITIAL.substr(
        0,
        1,
      ).toUpperCase()}${BREAKPOINT_INITIAL.substr(1)}`,
    ].join(STRING_EMPTY)

    return parseFloat(_item.dataset[_tween_delay_seconds]) || 0
  }

  function get_item_y(_item) {
    return _item.getBoundingClientRect().top
  }

  function get_real_duration() {
    const _reducer = (_accumulator, _current_item) => {
      return _accumulator + $(_current_item).outerHeight(true)
    }

    return (
      $carousel_image_items.toArray().reduce(_reducer, 0) -
      parseInt($carousel_text_container.css('paddingTop'), 10) -
      $carousel_image_items.last().innerHeight() +
      parseInt($carousel_image_items.last().css('paddingTop'), 10)
    )
  }

  function get_view() {
    if (view_is_mobile()) return BREAKPOINT_MOBILE
    if (view_is_minitablet()) return BREAKPOINT_MINITABLET
    if (view_is_tablet()) return BREAKPOINT_TABLET
    if (view_is_desktop()) return BREAKPOINT_DESKTOP
  }

  function initialize_page() {
    unmove_unmatched_items()

    $mobile_carousel
      .slick({
        responsive: [
          {
            breakpoint: WIDTH_MIN_MINITABLET,
            settings: {
              arrows: false,
              autoplay: false,
              autoplaySpeed: SLIDE_DURATION_SECONDS * MILLISECONDS_ONE_SECOND,
              dots: true,
              mobileFirst: true,
            },
          },
        ],
      })
      .on('beforeChange', (_event, _slick, _index_current, _index_next) => {
        // Show text for new slide
        set_active_item(
          CLASS_CAROUSEL_TEXT_ITEM_MOBILE,
          CLASS_CAROUSEL_TEXT_ITEM_MOBILE_ACTIVE,
          _index_next,
        )
      })

    // Assign an index to each carousel slide for targeting
    $carousel_image_items.each((_index, _item) => {
      $(_item).data('index', _index)
    })

    $carousel_text_items
      .each((_index, _item) => {
        $(_item).data('index', _index)
      })
      .click((_event) => {
        const _index = $(_event.currentTarget).data('index'),
          _item = $carousel_image_items.eq(_index),
          _item_padding_top = parseInt($(_item).css('paddingTop'), 10),
          _offset_y =
            controller.info().size * TRIGGER_HOOK_CAROUSEL - _item_padding_top

        set_active_item(
          CLASS_CAROUSEL_TEXT_ITEM,
          CLASS_CAROUSEL_TEXT_ITEM_ACTIVE,
          _index,
        )

        TweenMax.to(window, 1, {
          scrollTo: {
            y: _item,
            offsetY: _offset_y,
          },
          ease: EASE_EXPO_IN_OUT,
          onStart: () => {
            is_autoscrolling = true
          },
          onComplete: () => {
            is_autoscrolling = false
          },
        })
      })
  }

  function item_is_visible(_item) {
    const _item_y_pixels = get_item_y(_item)

    return _item_y_pixels >= 0 && _item_y_pixels < window.innerHeight
  }

  function item_will_animate(_item) {
    const _item_y_pixels = get_item_y(_item)

    return _item_y_pixels >= 0
  }

  function on_all_items_revealed() {
    unmove_all($move_items.toArray())
  }

  function set_active_item(_selector, _class_active, _index) {
    $(`.${_selector}`)
      .removeClass(_class_active)
      .eq(_index)
      .addClass(_class_active)
  }

  function start_mobile_carousel() {
    const _refresh = true

    $mobile_carousel.slick(
      'setOption',
      'responsive',
      [
        {
          breakpoint: WIDTH_MIN_MINITABLET,
          settings: {
            arrows: false,
            autoplay: true,
            autoplaySpeed: SLIDE_DURATION_SECONDS * MILLISECONDS_ONE_SECOND,
            dots: true,
            mobileFirst: true,
          },
        },
      ],
      _refresh,
    )
  }

  function unmove(_items) {
    $(_items)
      .removeClass('move')
      .css({
        opacity: '',
        transform: '',
      })
  }

  function unmove_all(_items) {
    $(_items).each((_index, _item) => unmove(_item))
  }

  function unmove_unmatched_items() {
    $move_items.each((_index, _item) => {
      !$(_item).hasClass(CLASS_ANIMATION_INITIAL) && unmove(_item)
    })
  }

  function view_is_desktop() {
    return view_matches(WIDTH_MIN_DESKTOP)
  }

  function view_is_minitablet() {
    return view_matches(WIDTH_MIN_MINITABLET, WIDTH_MAX_MINITABLET)
  }

  function view_is_mobile() {
    return view_matches(null, WIDTH_MAX_MOBILE)
  }

  function view_is_tablet() {
    return view_matches(WIDTH_MIN_TABLET, WIDTH_MAX_TABLET)
  }

  function view_matches(_width_min, _width_max) {
    let _media_query

    if (_width_min && _width_max) {
      _media_query = `(min-width: ${_width_min}px) and (max-width: ${_width_max}px)`
    } else if (_width_min) {
      _media_query = `(min-width: ${_width_min}px)`
    } else {
      _media_query = `(max-width: ${_width_max}px)`
    }

    return matchMedia(`screen and ${_media_query}`).matches
  }
})
